<template>
  <div>
    <ActionSheet v-model="show_c" title="支付密码">
      <div class="paypassword-container">
        <PasswordInput :value="password" :length="6" :mask="true" />
        <div style="height: 260px">
          <NumberKeyboard
            :show="true"
            :transition="false"
            v-model="password"
            extra-key=" "
          />
        </div>
      </div>
    </ActionSheet>
  </div>
</template>

<script>
import { ActionSheet, PasswordInput, NumberKeyboard } from 'vant'
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  components: { ActionSheet, PasswordInput, NumberKeyboard },
  data() {
    return {
      password: '',
    }
  },
  watch: {
    password(val) {
      if (val.length === 6) {
        this.handleClick(val)
      }
    },
  },
  computed: {
    show_c: {
      get() {
        return this.show
      },
      set(val) {
        if (!val) {
          this.close()
        }
      },
    },
  },
  methods: {
    close() {
      this.password = ''
      this.$emit('update:show', false)
    },
    handleClick(val) {
      this.close()
      this.$emit('submit', val)
    },
  },
}
</script>

<style lang="less" scoped>
.paypassword-container {
  padding-top: 40px;
}
</style>